const axios = require('axios');
const env = process.env.NODE_ENV || 'development';
const config = require('../config.json')[env];
const btoa = require('btoa');
const basicAuth = 'Basic ' + btoa(config.api_credentials);

const instance = axios.create({
  baseURL: config.main_server,
  timeout: 800000,
  headers: {
    'content-type': 'application/json',
    'auth': basicAuth,
  },
});

const register = (values) => {
  return instance.post('/api/user/register', values)
}
const login = values => {
  return instance.post('/api/user/login', values)
}

const forgotPassword = values => {
  return instance.post('/api/user/forgot-password', values)
}

const resetPassword = values => {
  return instance.post('/api/user/reset-password', values)
}

const validatePasswordResetHash = values => {
  return instance.post('/api/user/validate-password-reset-hash', values)
}

const saveResetPassword = values => {
  return instance.post('/api/user/save-reset-password', values)
}

const addCompany = (values) => {
  return instance.post('/api/companies', values)
}

const addCompetitor = (values) => {
  return instance.post('/api/companies/competitors', values)
}
const updateCompany = (company, values) => {
  return instance.put('/api/companies', values, { params: { company } })
}

const registerCompany = (company, values) => {
  return instance.post('/api/companies/register', values, { params: { company } })
}

const createNewCompany = (company, values) => {
  return instance.post('/api/companies/create-new-company', values, { params: { company } })
}

const subscribeToAddCompany = (values) => {
  return instance.post('/api/subscribeToAdd', values)
}
const subscribeToEditCompany = (values) => {
  return instance.post('/api/subscribeToEdit', values)
}
const subscribeToMailchimp = (values) => {
  return instance.post('/api/subscribetomailchimp', values)
}
const contactmsg = (values) => {
  return instance.post('/api/contactmsg', values)
}
const getCompanies = (order, orderBy, offset, rowsPerPage, filter, type = 'companies') => {
  if (type == 'companies') {
    return instance.get('/api/companies', { params: { order, orderBy, offset, rowsPerPage, filter } })
  }
  else if (type == 'employees') {
    return instance.get('/api/employee', { params: { order, orderBy, offset, rowsPerPage, filter } })
  }
}

const getCompaniesForDir = (order, orderBy, offset, rowsPerPage, name) => {
  return instance.get('/api/companies/dir', { params: { order, orderBy, offset, rowsPerPage, name } })
}

const checkMonthlyDownloadLimit = () => {
  return instance.get('/api/user/check-monthly-download-limit')
}

const getHomepageDescription = () => {
  return instance.get('/api/companies/get-homepage-data')
}
const getCsvWithFilter = (filter) => {
  const Instance = axios.create({
    baseURL: config.main_server,
    responseType: 'blob',
    headers: {
      'auth': basicAuth,
    },
  });
  return Instance.get('/api/companies/csv-with-filter', { params: { filter } })
}

const getCompetitorsCsv = (company_id) => {
  const Instance = axios.create({
    baseURL: config.main_server,
    responseType: 'blob',
    headers: {
      'auth': basicAuth,
    },
  });
  return Instance.get('/api/companies/get-competitors-csv', { params: { company_id } })
}

const getTempCompanies = (order, orderBy, offset, rowsPerPage, filter) => {
  return instance.get('/api/companies/temp', { params: { order, orderBy, offset, rowsPerPage, filter } })
}

const getRecentlyAddedCompanies = () => {
  return instance.get('/api/companies/recently-added')
}

const getCompaniesByState = (order, orderBy, offset, rowsPerPage, state, statepage = 0) => {
  return instance.get('/api/companies/state', { params: { order, orderBy, offset, rowsPerPage, state, statepage } })
}
const getCompaniesByIndustry = (order, orderBy, offset, rowsPerPage, industry) => {
  return instance.get('/api/companies/industry', { params: { order, orderBy, offset, rowsPerPage, industry } })
}
const getCompaniesByIndustryCity = (order, orderBy, offset, rowsPerPage, industry, city) => {
  return instance.get('/api/companies/industry-city', { params: { order, orderBy, offset, rowsPerPage, industry, city } })
}
const getIndustryCityPage = ( industry, city) => {
  return instance.get('/api/companies/industry-city-page', { params: {industry, city } })
}
const getCompaniesByRegion = (order, orderBy, offset, rowsPerPage, region) => {
  return instance.get('/api/companies/region', { params: { order, orderBy, offset, rowsPerPage, region } })
}
const getCompaniesByCountry = (order, orderBy, offset, rowsPerPage, country) => {
  return instance.get('/api/companies/country', { params: { order, orderBy, offset, rowsPerPage, country } })
}
const getCompaniesByCity = (order, orderBy, offset, rowsPerPage, city, citypage = 0) => {
  return instance.get('/api/companies/city', { params: { order, orderBy, city, offset, rowsPerPage, citypage } })
}
const getCityPage = (city) => {
  return instance.get('/api/companies/citypage', { params: { city } })
}
const getTotalCount = () => {
  return instance.get('/api/companies/totalcount')
}
const getCompanyByName = (name, query) => {
  name = encodeURIComponent(name)
  return instance.get(`/api/companies/${name}`, { params: { order: query ? query.order : '', orderby: query ? query.orderby : '' } })
}

const getEmployeeByName = (name) => {
  name = encodeURIComponent(name)
  return instance.get(`/api/employee/${name}`)
}

const getTrendingNewCompanies = () => {

  return instance.get(`/api/companies/top-trending-news`)
}

const getEmpTitle = (name) => {
  name = encodeURIComponent(name)
  return instance.get(`/api/employee/get-top-titles/${name}`)
}

const getCompanyForCsv = () => {
  return instance.get(`/api/companies/makecsv`)
}
const get2kCompanyForCsv = () => {
  return instance.get(`/api/companies/makecsv/2k`)
}
const getCompanyForCsvInCity = (city) => {
  return instance.get(`/api/companies/makecsv/city`, { params: { city } })
}

const getCompanyForCsvInState = (state) => {
  return instance.get(`/api/companies/makecsv/state`, { params: { state } })
}

const getNewCompanies = () => {
  return instance.get('/api/companies/new')
}
const getFastestStartUps = (order, orderBy) => {
  return instance.get('/api/companies/fasteststartups')
}
const getBestEpisodes = (order, orderBy) => {
  return instance.get('/api/companies/bestepisodes')
}
const getReportAwards = () => {
  return instance.get('/api/reportawards')
}
const getDataForFilter = () => {
  return instance.get('/api/companies/filterdata')
}

const getDataForCompanyEditFilter = () => {
  return instance.get('/api/companies/edit-company-filterdata')
}

const getCompanyForCsvInIndustry = (industry) => {
  return instance.get(`/api/companies/makecsv/industry`, { params: { industry } })
}

const getHomeNewsData = () => {
  return instance.get(`/api/companies/get-homenews-data`)
}

const signInWithGoogle = (token, landingPage) => {
  return instance.post('/api/user/login-with-google', { token, landingPage })
}

const getUserDetail = () => {
  return instance.get('/api/user/get-user-detail')
}

const getCompanyForSerpCrawling = (offset, orderBy, sort) => {
  return instance.get('/api/companies/serp-crawl', { params: { orderBy, sort, offset } })
}

const insertSERPdata = (id, data) => {
  return instance.post('/api/companies/serp-crawl', { id, data })
}

const getEmployeePhoneEmail = (id) => {
  return instance.get('/api/employee/get-phone-email', { params: { id } })
}

const getCompanyEmployeesByTitle = (company_id, title) => {
  return instance.get('/api/employee/get-company-employees-by-title', { params: { company_id, title } })
}

module.exports = {
  login,
  register,
  forgotPassword,
  resetPassword,
  validatePasswordResetHash,
  saveResetPassword,
  addCompany,
  getCompanies,
  addCompetitor,
  getTotalCount,
  getCompanyByName,
  getTrendingNewCompanies,
  getCompaniesByState,
  getCompaniesByCountry,
  getCompaniesByIndustry,
  getCompaniesByRegion,
  getCompanyForCsv,
  getNewCompanies,
  getTempCompanies,
  subscribeToAddCompany,
  subscribeToEditCompany,
  subscribeToMailchimp,
  getCompaniesByCity,
  getCompanyForCsvInCity,
  getCompanyForCsvInState,
  getCompanyForCsvInIndustry,
  getFastestStartUps,
  getBestEpisodes,
  getReportAwards,
  getDataForFilter,
  getDataForCompanyEditFilter,
  contactmsg,
  getCsvWithFilter,
  getCompetitorsCsv,
  updateCompany,
  registerCompany,
  getCompaniesForDir,
  getCityPage,
  checkMonthlyDownloadLimit,
  getHomeNewsData,
  getHomepageDescription,
  get2kCompanyForCsv,
  signInWithGoogle,
  createNewCompany,
  getRecentlyAddedCompanies,
  getCompanyForSerpCrawling,
  insertSERPdata,
  getEmployeePhoneEmail,
  getEmployeeByName,
  getEmpTitle,
  getUserDetail,
  getCompanyEmployeesByTitle,
  getCompaniesByIndustryCity,
  getIndustryCityPage
}



// WEBPACK FOOTER //
// ./client/src/utils/service.js